import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import VentureDetail from "./components/VentureDetail";
import Ventures from "./pages/Ventures";

function App() {
  return (
    <Router>
      <Navbar />
      <div className="pt-20">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/ventures/:slug" element={<VentureDetail />} />
          <Route path="/ventures" element={<Ventures />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
